/* stylelint-disable */
import React from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import openLinkIcon from '../../assets/whiteOpenLinkIcon.png';
import MenuIcon from './MenuIcon';
import {translateMenuTitle} from './menuText';
import {getAppRoutePath, getMenuHref} from '../appRoutes';
import {CONFIG_CONSTANT} from '../../Constants/ConfigsConstants';
import {useLocale} from '../../Localization/LocaleContext';
import trackMenuClick from './trackMenuClick';

const SubMenu = ({
  sub_menu,
  main_menu,
  background_color,
  text_color,
  setCurrentMenuPosition,
  onClose,
  group_id,
  visible_sub_menus,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {translate} = useLocale();
  const menu_click = (menu, event) => {
    // Prevent default behavior to avoid page reload
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    onClose?.();
    trackMenuClick(menu, main_menu);

    console.log('=== SubMenu menu_click ===');
    console.log('Menu item:', menu);
    console.log('Current location:', location.pathname);

    // Dynamic side menu via iframe side panel
    if (menu?.is_dynamic_side_menu && menu?.is_open_via_iframe_sidepan) {
      // Use href as the primary URL since it now contains the specific workflow page
      const iframeUrl = menu?.href || menu?.iframe_url || '';
      const iframeHeight = menu?.iframe_height || 'calc(100vh - 120px)';
      const title = menu?.title || 'Integration';

      const targetUrl = getAppRoutePath(menu);

      // Use React Router navigation WITHOUT page reload
      navigate(targetUrl, {
        state: {
          integration: {
            url: iframeUrl,
            title: title,
            height: iframeHeight,
          },
        },
        replace: false,
      });

      console.log('Navigate() called successfully (no page reload)');
    } else {
      const menuHref = getMenuHref(menu);
      console.log('Regular navigation to:', menuHref);
      // If the menu item has a URL and no sub-menus, navigate
      if (menuHref && (!menu?.sub_menus || menu?.sub_menus?.length === 0)) {
        menu?.isOpenNewTab && menu?.key_name !== 'social_connect'
          ? window.open(menuHref, '_blank')
          : navigate(menuHref);
      }
    }
  };
  const allSideMenus = [
    ...(CONFIG_CONSTANT.SUPERADMIN?.sidebar_setup ?? []),
    ...(CONFIG_CONSTANT.SUPERADMIN?.dynamic_sidebar_setup ?? []),
    ...(CONFIG_CONSTANT?.DEFAULT_EXTENSION ?? []),
  ];
  const parentMenuSetup = allSideMenus.find(
    setup_menu => setup_menu?.key_name === main_menu?.key_name,
  );
  const fallbackVisibleSubMenus = sub_menu?.filter(s_menu => {
    if (s_menu?.isShow === false) return false;
    if (s_menu?.is_fixed || s_menu?.is_dynamic_side_menu) return true;
    const childSetup = allSideMenus.find(
      setup_menu => setup_menu?.key_name === s_menu?.key_name,
    );
    if (childSetup) return childSetup.feature_activated !== false;
    if (parentMenuSetup) return parentMenuSetup.feature_activated !== false;
    return true;
  });
  const visibleSubMenus = visible_sub_menus ?? fallbackVisibleSubMenus;
  return (
    <div
      className="dark-side-submenu pointer-events-auto min-h-[150px] w-[255px] rounded-lg"
      style={{background: background_color, color: text_color}}>
      <p className="side-menu-label dark-side-submenu-title py-2 px-4">{translateMenuTitle(main_menu, translate)}</p>

      <div className=" mt-3 px-4 flex flex-col gap-3 pb-3">
        {visibleSubMenus?.map((menu, menuIndex) => {
            return (
              <div
                key={`submenu-${menu.key_name || menu.id || menu.title || 'item'}-${menuIndex}`}
                className="flex min-h-9 items-center justify-start gap-4 cursor-pointer"
                onClick={e => menu_click(menu, e)}>
                <MenuIcon title={menu.title} size={20} color={text_color} />
                <div className="dark-side-submenu-item flex items-center justify-start leading-5">
                  <p className="side-menu-label min-w-[160px] text-sm font-medium leading-5">{translateMenuTitle(menu, translate)}</p>
                  {menu?.isOpenNewTab && (
                    <img
                      style={{width: 14, height: 14, minWidth: 14}}
                      src={openLinkIcon}
                      alt={translate('common.open_in_a_new_tab', 'Open in a new tab')}
                    />
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SubMenu;
